function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { CurrentCustomerIdSelector, CurrentCustomerCurrencyCodeSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { OfferingIsOffCycleMapSelector } from '../../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveSubscriberOfferingDetail } from '../../../../../../reducers/actions/customer.actions';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { IsFetchingOfferDetailsSelector, SelectedOfferingAndOptionsSelector, SubscriberServicesWithFormatedServicesSelector, SelectedOfferingInventoryItemsSelector, SelectedOfferingInventoryItemsCountSelector } from '../../../../../../reducers/selectors/search.subscriber.offerings.selectors';
var SubscriberOfferController = /*#__PURE__*/function () {
  function SubscriberOfferController($ngRedux, uiNotificationService) {
    _classCallCheck(this, SubscriberOfferController);
    this.fetchOfferingDetails = this.fetchOfferingDetails.bind(this);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(SubscriberOfferController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveSubscriberOfferingDetail: retrieveSubscriberOfferingDetail
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          inventoryItems: SelectedOfferingInventoryItemsSelector(store),
          inventoryItemsCount: SelectedOfferingInventoryItemsCountSelector(store),
          isFetchingOfferDetails: IsFetchingOfferDetailsSelector(store),
          offeringIsOffCycleMap: OfferingIsOffCycleMapSelector(store),
          selectedOffering: SelectedOfferingAndOptionsSelector(store),
          selectedOfferingServices: SubscriberServicesWithFormatedServicesSelector(store),
          subscriberCurrencyCode: CurrentCustomerCurrencyCodeSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.fetchOfferingDetails();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.selectedOfferingInstanceId && changesObj.selectedOfferingInstanceId.currentValue && this.actions) {
        this.fetchOfferingDetails();
      }
    }
  }, {
    key: "fetchOfferingDetails",
    value: function fetchOfferingDetails() {
      var _this2 = this;
      if (this.selectedOfferingInstanceId) {
        var _this$state$offeringI;
        this.actions.retrieveSubscriberOfferingDetail(this.state.currentCustomerId, this.selectedOfferingInstanceId, (_this$state$offeringI = this.state.offeringIsOffCycleMap) === null || _this$state$offeringI === void 0 ? void 0 : _this$state$offeringI[this.selectedOfferingInstanceId]).then(function (response) {
          return _this2.actions.retrieveOfferingsMetadata([response.SubscriberOffer.OfferingId]);
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "onRefreshConvergentBillerDetails",
    value: function onRefreshConvergentBillerDetails() {
      this.refreshConvergentBillerDetails && this.refreshConvergentBillerDetails();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    refreshConvergentBillerDetails: '&?',
    selectedOfferingInstanceId: '<',
    showStatusIndicator: '<?'
  },
  template: require('./subscriber.offer.html'),
  controller: SubscriberOfferController
};